import React from 'react';
import PageLayout from '../components/PageLayout';

/**
 * Equipment Guide page component
 */
const EquipmentGuidePage: React.FC = () => {
  return (
    <PageLayout 
      title="Equipment Guide" 
      subtitle="Expert recommendations to help you choose the right gear"
      backgroundImage="https://images.pexels.com/photos/6574647/pexels-photo-6574647.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section>
        <h2>Find the Right Equipment for Your Game</h2>
        <p>
          Whether you're just starting out or looking to upgrade your current set, choosing the right 
          golf equipment can significantly impact your performance and enjoyment of the game. Our 
          experts have put together comprehensive guides to help you make informed decisions.
        </p>
      </section>
      
      <section>
        <h2>Equipment Categories</h2>
        <div className="blog-posts">
          <div className="blog-post-card">
            <div 
              className="blog-post-image"
              style={{ backgroundImage: `url(https://images.pexels.com/photos/6577388/pexels-photo-6577388.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)` }}
            ></div>
            <div className="blog-post-content">
              <h3 className="blog-post-title">Drivers & Woods</h3>
              <p className="blog-post-excerpt">Find the perfect driver to maximize your distance off the tee, with recommendations for different swing speeds and player types.</p>
              <div className="blog-post-link">Read Guide →</div>
            </div>
          </div>
          
          <div className="blog-post-card">
            <div 
              className="blog-post-image"
              style={{ backgroundImage: `url(https://images.pexels.com/photos/6974/golf-green-putting-hole.jpg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)` }}
            ></div>
            <div className="blog-post-content">
              <h3 className="blog-post-title">Putters</h3>
              <p className="blog-post-excerpt">Explore different putter styles and technologies to help you sink more putts and lower your scores on the green.</p>
              <div className="blog-post-link">Read Guide →</div>
            </div>
          </div>
          
          <div className="blog-post-card">
            <div 
              className="blog-post-image"
              style={{ backgroundImage: `url(https://images.pexels.com/photos/6578275/pexels-photo-6578275.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)` }}
            ></div>
            <div className="blog-post-content">
              <h3 className="blog-post-title">Wedges</h3>
              <p className="blog-post-excerpt">Master your short game with the right wedge setup, including bounce and grind options for different course conditions.</p>
              <div className="blog-post-link">Read Guide →</div>
            </div>
          </div>
        </div>
      </section>
      
      <section>
        <h2>Latest Equipment Reviews</h2>
        <div className="content-card">
          <h3>TaylorMade Stealth 2 Driver (2025 Review)</h3>
          <p>
            The new TaylorMade Stealth 2 builds on the success of the original Stealth with improved 
            carbon face technology and enhanced forgiveness. Our testing showed significant gains in 
            ball speed and reduced spin for most players, making this a solid upgrade for those looking 
            to add distance off the tee.
          </p>
          <div className="blog-post-link">Read Full Review →</div>
        </div>
        
        <div className="content-card" style={{ marginTop: '2rem' }}>
          <h3>Titleist T200 Irons (2025 Review)</h3>
          <p>
            The latest T200 irons from Titleist offer a perfect blend of forgiveness and workability 
            for mid-handicap players. With a slimmer topline than previous models but maintaining 
            impressive perimeter weighting, these irons deliver consistent distance without sacrificing 
            feel or control.
          </p>
          <div className="blog-post-link">Read Full Review →</div>
        </div>
      </section>
      
      <section>
        <h2>Golf Technology</h2>
        <div className="two-column-content">
          <div className="content-card">
            <h3>Launch Monitors</h3>
            <p>
              Modern launch monitors provide crucial data to help you understand your swing and optimize 
              your equipment choices. Our guides break down the different options at various price points, 
              from portable personal devices to professional studio systems.
            </p>
            <div className="blog-post-link">Explore Launch Monitors →</div>
          </div>
          
          <div className="content-card">
            <h3>Golf GPS & Rangefinders</h3>
            <p>
              Accurate distance information is essential for course management and club selection. 
              Compare the latest GPS watches, handheld devices, and laser rangefinders to find the 
              right option for your game and budget.
            </p>
            <div className="blog-post-link">Compare Distance Tools →</div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default EquipmentGuidePage;
